import { HSE_TERMS, type HseTermKey } from '../constants/hseTerms';
import type { HseWeekExposureDraft, HseWeeklyDraft, HseWeeklyReport } from '../types/hse-weekly-report.type';

export function emptyDraft(): HseWeeklyDraft {
  return Object.fromEntries(
    HSE_TERMS.map((term) => [term.key, { notes: '', weeklyCount: '0' }]),
  ) as HseWeeklyDraft;
}

export function draftFromReport(report: HseWeeklyReport): HseWeeklyDraft {
  const draft = emptyDraft();
  for (const row of report.rows) {
    if (row.term_key in draft) {
      draft[row.term_key as HseTermKey] = {
        notes: row.notes ?? '',
        weeklyCount: String(row.weekly_count ?? 0),
      };
    }
  }
  return draft;
}

export function emptyExposure(): HseWeekExposureDraft {
  return { hoursWorked: '', headcount: '' };
}

export function exposureFromReport(report: HseWeeklyReport): HseWeekExposureDraft {
  return {
    hoursWorked: report.hours_worked === null || report.hours_worked === undefined ? '' : String(report.hours_worked),
    headcount: report.headcount === null || report.headcount === undefined ? '' : String(report.headcount),
  };
}
